import * as React from 'react';

import { App, Button, Modal, Typography } from 'antd';

import { useMutation } from '@tanstack/react-query';
import { Formik, Form as FormikForm } from 'formik';
import type { AddressFormKit, AddressFormValues, AddressKitInfo } from 'v2/interfaces/addressKit';
import kitService from 'v2/services/kit';

import Address, { mapCity } from './Address';
import ConfirmUpdateAddress from './ConfirmUpdateAddress';
import ModalConfirmAddressSchema from './validation';

type ConfirmAddressToKitsProps = {
  isOpen: boolean;
  setIsOpen: (prev: boolean) => void;
  data: AddressKitInfo;
};

const ConfirmAddressToKits = ({ isOpen, setIsOpen, data: { address, name } }: ConfirmAddressToKitsProps) => {
  const { message } = App.useApp();
  const [isOpenConfirmUpdateAddress, setIsOpenConfirmUpdateAddress] = React.useState(false);

  const saveNewAddressToKit = useMutation({
    mutationFn: (data: AddressFormKit) => {
      const formattedData = {
        ...data,
        number: data.number || null
      };

      return kitService.saveNewAddressToKit(formattedData);
    }
  });

  const onSubmit = async (values: AddressFormValues) => {
    try {
      await saveNewAddressToKit.mutateAsync({
        ...values,
        city: typeof values.city === 'string' ? values.city : values.city.value
      });
      setIsOpen(false);
      setIsOpenConfirmUpdateAddress(true);
    } catch (error) {
      message.error(typeof error === 'string' ? error : 'Não foi possível salvar o endereço.');
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Formik
        initialValues={{
          zipcode: address?.zipcode || '',
          street: address?.street || '',
          neighborhood: address?.neighborhood || '',
          state: address?.state || '',
          number: address?.number || '',
          noNumber: address?.number === null,
          city: address?.city ? mapCity(address?.city, address?.state) : null,
          additionalInfo: address?.additionalInfo || '',
          phone: address?.phone || '',
          cpf: address?.cpf || ''
        }}
        onSubmit={onSubmit}
        validationSchema={ModalConfirmAddressSchema}
      >
        {formikProps => {
          return (
            <>
              <FormikForm>
                <Modal
                  open={isOpen}
                  onCancel={handleClose}
                  width={900}
                  title='Atualizar endereço de entrega'
                  closable
                  footer={
                    <div className='flex flex-wrap items-center justify-end gap-2'>
                      <Button type='text' onClick={handleClose} disabled={saveNewAddressToKit.isPending}>
                        Cancelar
                      </Button>
                      <Button
                        type='primary'
                        htmlType='submit'
                        loading={saveNewAddressToKit.isPending}
                        onClick={formikProps.submitForm}
                      >
                        Salvar endereço de entrega
                      </Button>
                    </div>
                  }
                >
                  <div className='flex flex-col gap-4'>
                    <Typography.Text strong>Informe seu novo endereço de entrega:</Typography.Text>
                    <Address />
                  </div>
                </Modal>
              </FormikForm>
            </>
          );
        }}
      </Formik>
      <ConfirmUpdateAddress isOpen={isOpenConfirmUpdateAddress} setIsOpen={setIsOpenConfirmUpdateAddress} name={name} />
    </>
  );
};

export default ConfirmAddressToKits;
